<template>
	<v-card>
		<v-toolbar class="bg-white">
			<div class="custom-icon-wrapper">
				<v-icon @click="closeDialog()">custom-icon left-arrow-icon</v-icon>
			</div>
			<v-toolbar-title class="size-18">Configure Signature</v-toolbar-title>
			<v-spacer></v-spacer>
			<div class="custom-icon-wrapper ml-3">
				<v-icon @click="closeDialog()">custom-icon mdi-close</v-icon>
			</div>
        </v-toolbar>
		<div class="dialog-body">
            <div class="row m-auto">
                <div class="col-md-3 p-0" style="width: 28%">
                    <div class="bg-white p-1">
                        <div class="p-3 scrollable-container">
                            <div class="d-flex align-items-start">
                                <div class="template_name">
									{{attachementHeading}}
								</div>
							</div>
							<div class="d-flex gap-5 my-5">
								<div class="h6 text-secondary mt-2">Signees</div>
								<div style="margin-left: 135px">
									<v-btn v-if="(maxNumberOfSigners == 0 && signers.length == 0) || maxNumberOfSigners > 0" depressed color="light-blue" @click="doneAttachment" class="mr-5">Done</v-btn>
									<v-btn v-if="maxNumberOfSigners == 0 && signers.length == 0" depressed color="primary" @click="addAttachment">Add</v-btn>
								</div>
							</div>
							<div class="row">
								<div v-if="maxNumberOfSigners > 0">
									<v-list-item v-for="index in maxNumberOfSigners" :key="index">
										<div style="padding: 0px 10px 0px 0px;">
											Signee {{index}} *
											<multiselect
												style="width: 300px" v-model="signees[index]" label="name" track-by="id" open-direction="bottom" placeholder="Not assigned yet"
												:options="users" :searchable="true" :loading="loading" :internal-search="false" :clear-on-select="true" :close-on-select="true"
												:options-limit="300" :show-no-results="false" :hide-selected="false" 
												:value="undefined" :multiple="false" @search-change="asyncFindUser"
												@close="users = []">
												<template slot="noOptions" slot-scope="props">
													{{$t("res_Msgs_EmptySearch")}}
												</template>
											</multiselect>
										</div>
									</v-list-item>
								</div>
								<div v-if="signers.length > 0">
									<v-expansion-panels focusable v-model="expansionPanels">
										<v-expansion-panel v-for="(item, i) in signers" :key="i" @change="signatureConfigurationPanelChanged(i)">
											<v-expansion-panel-header>{{ item.name }}</v-expansion-panel-header>
											<v-expansion-panel-content>
												<div class="mx-3">
													<p>Apply to</p>
													<v-radio-group v-model="item.applyTo">
														<div class="d-flex flex-wrap justify-space-between align-baseline">
															<v-radio :key="'this' + i" 		label="This Page" 	value="this"		></v-radio>
															<v-radio :key="'all' + i" 		label="All Pages" 	value="all"			></v-radio>
															<v-radio :key="'range' + i" 	label="Range" 		value="range" 		></v-radio>
															<v-radio :key="'specify' + i" 	label="Specific" 	value="specific" 	></v-radio>
														</div>
													</v-radio-group>
													<div v-if="item.applyTo == 'range'" class="d-flex justify-space-between flex-wrap">
														<div>
															<p>From </p>
															<v-text-field v-model="item.from" type="number" number label="" solo></v-text-field>
														</div>
														<div>
															<p>To</p>
															<v-text-field v-model="item.to" type="number" number label="" solo></v-text-field>
														</div>
													</div>
													<div v-if="item.applyTo == 'specific'" class="d-flex justify-space-between flex-wrap">
														<div>
															<p>Pages Number</p>
															<v-text-field v-model="item.specific" number label="1,2,3,4" solo></v-text-field>
														</div>
													</div>
													<div class="d-flex justify-space-between flex-wrap my-3">
														<div>
															<p>Language </p>
															<v-radio-group v-model="item.language"  mandatory>
																<div class="d-flex flex-wrap justify-space-between align-baseline">
																	<v-radio :key="'EN' + i" label="EN" value="EN"></v-radio>
																	<v-radio :key="'AR' + i" label="AR" value="AR"></v-radio>
																</div>
															</v-radio-group>
														</div>
														<div>
															<p>Alignment</p>
															<v-tabs v-model="item.alignment">
																<v-tab>
																	<v-icon :key="'left' + i" value="left">mdi-format-align-left</v-icon>
																</v-tab>
																<v-tab>
																	<v-icon :key="'center' + i" value="center">mdi-format-align-center</v-icon>
																</v-tab>
																<v-tab>
																	<v-icon :key="'right' + i" value="right">mdi-format-align-right</v-icon>
																</v-tab>
															</v-tabs>
														</div>
													</div>
													<div>
														<div>Show</div>
														<div class="d-flex flex-wrap justify-space-between align-baseline">
															<v-checkbox v-model="item.showName" 	:key="'Name' + i" label="Name" input-value="true"></v-checkbox>
															<v-checkbox v-model="item.showJobTitle" :key="'Job' + i" label="Job Title"></v-checkbox>
															<v-checkbox v-model="item.showDate" 	:key="'Date' + i" label="Date"></v-checkbox>
														</div>
													</div>
													<div>
														x:<v-text-field v-model="item.x" label="" solo /><br />
														y:<v-text-field v-model="item.y" label="" solo  /><br />
														left:<v-text-field v-model="item.left" label="" solo /><br />
														top:<v-text-field v-model="item.top" label="" solo  />
													</div>
													<v-divider></v-divider>
													<v-row class="mt-3" style="display: flex; justify-content: space-evenly; align-items: center;">
														<div class="text-end" style="width: auto; margin-top: 10px;">
															<v-btn color="light-blue" @click="resetSignatureConfiguration(i)" :disabled="!fileViewer">Reset</v-btn>
															<v-btn color="light-blue" @click="removeSignature(i)" :disabled="!fileViewer">Remove</v-btn>
															<v-btn color="light-blue" @click="addSignatureToFile(i)" :disabled="!fileViewer" v-if="item.showAdd">Add</v-btn>
															<v-btn color="light-blue" @click="applyChanges(i)" :disabled="!fileViewer" v-if="item.showApplyChanges">Save</v-btn>
														</div>
													</v-row>
												</div>
											</v-expansion-panel-content>
										</v-expansion-panel>
									</v-expansion-panels>
								</div>
								<div v-if="maxNumberOfSigners == 0 && signers.length == 0">
									<br><br>
									<br>
									<div class="previous" v-for="id, index in dynamicUserList" v-bind:key="index">
										<v-btn @click="deleteVisa(index)">x</v-btn>
										<div style="padding: 0px 10px 0px 0px;">
											Signee {{index}} *
											<multiselect style="width: 300px" v-model="dynamicSignees[index]" label="name" track-by="id"
												open-direction="bottom" placeholder="Not assigned yet" :options="users" :searchable="true" :loading="loading"
												:internal-search="false" :clear-on-select="true" :close-on-select="true" :options-limit="300"
												:show-no-results="false" :hide-selected="false" :multiple="false" 
												@search-change="asyncFindUser" @close="users = []">
												<template slot="noOptions" slot-scope="props">
													{{$t("res_Msgs_EmptySearch")}}
												</template>
											</multiselect>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-9">
                    <div class="container h-100 position-relative">
						<v-card id="divCanvas" v-if="fileViewer" class="my-3 overflow-y-auto mx-10" style="width: 95%;">
							<div>
								<v-btn @click="printFinalSignatureList">Print</v-btn>
							</div>
							<div>
								<span>
									<button :disabled="page <= 1" @click="displayPrevPage">❮</button>
									{{ page }} / {{ pageCount }}
									<button :disabled="page >= pageCount" @click="displayNextPage">❯</button>
								</span>
							</div>
							<div style="overflow: scroll" class="p-0 scrollable-container choose-template">
								<div id="div1">
									<vue-pdf-embed :source="fileSource" ref="pdfRef" :page="page" @rendered="handleDocumentRender" />
								</div>
							</div>
            			</v-card>
                        <div class="d-flex justify-content-end align-items-center bottom-action-bar m-0 gap-2">
                            <v-btn color="light-blue">Cancel</v-btn>
                            <v-btn color="primary" @click="saveSignatures" v-if="fileViewer">Save</v-btn>
                        </div>
                    </div>
                </div>
			</div>
		</div>
	</v-card>
</template>

<script>
  	import axios from 'axios';
    import constants from '@/assets/js/constants';
	import multiselect  from 'vue-multiselect'
	import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed'
	
	export default {
		name: 'SignatureConfigure',
		components: { multiselect, VuePdfEmbed},
        props:
        {
			documentId: {type: [String, Number], default: 0},
			attachmentId: {type: Number, default: 0},
			updateCount: {type: Number},
			signeesList: { type: Array, default: [] },
			maxNumberOfSigners: {type: Number, default: 0},
			attachementHeading: {type: String},
            dialogModelShow: { type: Boolean, default: false },
		},
		data() {
            return {
				fixedHeaderSize: 0, // 57px (21px + 36px) is the header size above the pdf viewer
				expansionPanels: -1,
				loadFirstTime: false,
				
				documentIsRegistered: false,
				signees: [],
				dynamicSignees: [],
				users: [],
				signers: [],
				dynamicUserList:[],
				fileSource: [],
				show: [],
				index: null,
				loading: false,
				fileViewer: false,
				counter: 0,
				signatureSource: [],
				
				signatureCount: 0,

				page: 1,
      			pageCount: 1,

				finalSignatureList: [],
			};
		},
        watch: 
        {
            dialogModelShow(newVal, oldVal)
            {
                if (newVal != oldVal)
                {
                    if (newVal == true)
                    {
						this.loadFirstTime = true
						this.getAttachment()
					}    
                    else
                    {
						this.loadFirstTime = false
                        this.reset()
                    }
                }
            }
        },
		mounted ()
		{
			this.loadFirstTime = true
			this.getAttachment()
		},
		methods:
		{
			setXAndY(x, y, left, top)
			{
				this.signers[this.index].x = x
				this.signers[this.index].y = y
				this.signers[this.index].left = left
				this.signers[this.index].top = top
			},
			printFinalSignatureList()
			{
				console.log(this.finalSignatureList)
			},
			getAttachment: async function (successHandler) 
			{
				if (this.attachmentId == 0)
					return
				
				this.documentIsRegistered = window.documentView.document.isRegistered
				if (this.documentIsRegistered == false)
				{
					alert('Document is not saved. Please save the document first.')
					return
				}

				if (window.documentView.template_isWorkflow == true)
				{
					var signatureCount = window.documentView.template_signatureCount
					var signersList = window.documentView.template_signersList
					if (signatureCount == 0 || signersList == null || signersList.length == 0)
					{
						alert('No signers configured for this document. Please configure signers first.')
						return
					}
				}

				console.log('template_signatureCount: ' + window.documentView.template_signatureCount)
				console.log('template_isWorkflow: ' + window.documentView.template_isWorkflow)

				await axios.get(constants.baseApiUrl + "Document/GetAttachmentData?documentId=" + this.documentId + "&attachmentId=" + this.attachmentId, {headers: constants.headers, responseType: 'blob'})
					.then(response => 
					{
						this.fileViewer = true

						const objectUrl = URL.createObjectURL(new Blob([response.data]))
						this.fileSource = { url: objectUrl, isEvalSupported: false }

						successHandler()
					})
					.catch(err => console.warn(err))
        	},
			getConfiguredSignatures()
			{
				axios.get(constants.baseApiUrl + "Document/GetSignatureConfiguration?documentId=" + this.documentId + "&attachmentId=" + this.attachmentId)
					.then(response => 
					{
						if (response.data != '')
						{
							response.data.forEach((item, index) => {
								this.finalSignatureList.push(item)
							})

							this.finalSignatureList.forEach((item, index) => {
								if (item.PageNo == this.page)
								{
									item.SignInfo.forEach((item2, index2) => 
									{
										var item3 = this.signers.find(x => x.id == item2.SignatureNo.toString())
										if (item3 != undefined)
										{
											item3.x = item2.X
											item3.y = item2.Y
										}
									})
								}
							})

							this.drawSignaturesOnPage()
						}
					})
					.catch(err => console.warn(err))
			},
			handleDocumentRender()
			{
				if (this.loadFirstTime == true)
				{
					this.pageCount = this.$refs.pdfRef.pageCount
					window.setXAndY = this.setXAndY
					this.getConfiguredSignatures()
					this.populateSignersList(this.signeesList)
					this.loadFirstTime = false
				}

				if (this.handleFunctionAfterRender != null)
				{
					this.handleFunctionAfterRender()
					this.handleFunctionAfterRender = null
				}
			},
			resetSignatureConfiguration(index)
			{
				this.signers[index].applyTo = 'this'
				this.signers[index].language = 'EN'
				this.signers[index].alignment = 'left'
				this.signers[index].showName = true
				this.signers[index].showJobTitle = true
				this.signers[index].showDate = false
			},
			addSignatureToFile(index) 
			{
				this.index = index

				var iSignature = document.createElement('div')
				iSignature.className = 'movable_signature'
				iSignature.id = "iSign" + this.index

				var header = document.createElement('div')
				header.innerHTML = ''
				header.className = 'header'
				header.id = iSignature.id + "header"
				iSignature.appendChild(header)

				// Signature
				var divSignerImage = document.createElement('div');
				divSignerImage.className = 'signature';
				divSignerImage.innerHTML = 'Signature ' + (index + 1);

				// text
				var divText = document.createElement('div')
				divText.id = "text" + this.index
				divText.className = 'text'
				divText.innerHTML = ''				
				if (this.signers[index].showName == true)
					divText.innerHTML += this.signers[index].name + '<br />'

				if (this.signers[index].showJobTitle == true)
					divText.innerHTML += this.signers[index].jobTitle + '<br />'

				if (this.signers[index].showDate == true)
					divText.innerHTML += new Date().toLocaleDateString("en-GB")

				if (this.signers[index].alignment == 0)
					divText.style.justifyContent = 'flex-start'

				else if (this.signers[index].alignment == 1)
					divText.style.justifyContent = 'center'

				else if (this.signers[index].alignment == 2)
					divText.style.justifyContent = 'flex-end'

				var content = document.createElement('div')
				content.className = 'content';
				content.id = "content" + this.index;
				content.appendChild(divSignerImage);
				content.appendChild(divText);
				
				iSignature.appendChild(content);

				// document.getElementById('div1').appendChild(iSignature);
				document.getElementsByClassName('annotationLayer')[0].appendChild(iSignature);

				var currentContainerRect = document.getElementsByTagName('canvas')[0].getBoundingClientRect()
				var currentContainerWidth = parseInt(document.getElementsByTagName('canvas')[0].style.width.replace('px',''))
				var currentContainerHeight = parseInt(document.getElementsByTagName('canvas')[0].style.height.replace('px',''))
				var widthScale = 1 / parseInt(document.getElementsByTagName('canvas')[0].style.width.replace('px',''))
				var heightScale = 1 / parseInt(document.getElementsByTagName('canvas')[0].style.height.replace('px',''))

				var orginalContainerWidth = 1 / widthScale
				var xCorrdinate = (this.signers[index].x / orginalContainerWidth) * currentContainerWidth 
				var left = xCorrdinate - currentContainerRect.x

				var orginalContainerHeight = 1 / heightScale
				var yCorrdinate = (this.signers[index].y / orginalContainerHeight) * currentContainerHeight
				var top = yCorrdinate - currentContainerRect.y + this.fixedHeaderSize;

				iSignature.style.top = top + 'px'
				iSignature.style.left = left + 'px'

				this.signatureCount += 1;

				if (this.signers[index].applyTo == 'this')
				{
					var signatureObj = this.getSigntureObject(this.page, this.index)
					this.addItemToFinalSignaturesList(signatureObj, this.page)
				}
				else if (this.signers[index].applyTo == 'all')
				{
					for (var i = 0; i < this.pageCount; i++)
					{
						var signatureObj = this.getSigntureObject(i + 1, this.index)
						this.addItemToFinalSignaturesList(signatureObj, i + 1)
					}
				}
				else if (this.signers[index].applyTo == 'range')
				{
					for (var i = this.signers[index].from - 1; i < this.signers[index].to; i++)
					{
						var signatureObj = this.getSigntureObject(i + 1, this.index)
						this.addItemToFinalSignaturesList(signatureObj, i + 1)
					}
				}
				else if (this.signers[index].applyTo == 'specific')
				{
					var arrItems = this.signers[index].specific.split(',')
					for (var i = 0; i < this.pageCount; i++)
					{
						var signatureObj = this.getSigntureObject(i + 1, this.index)
						this.addItemToFinalSignaturesList(signatureObj, i + 1)
					}
				}
				
				// dragElement(iSignature);
				this.signatureConfigurationPanelChanged(index)
			},
			addItemToFinalSignaturesList(signatureObj, pageNumber)
			{
				var itemAdded = false
				this.finalSignatureList.forEach(function (item) 
				{
					if (item.PageNo == pageNumber)
					{
						itemAdded = true
						item.SignInfo.push(signatureObj)
					}
				})

				if (itemAdded == false)
				{
					this.finalSignatureList.push({ "PageNo": pageNumber, "SignInfo": [signatureObj] })
				}
			},
			drawSignatureElement(signatureElement)
			{
				var iSignature = document.createElement('div')
				iSignature.className = 'movable_signature'
				iSignature.id = "iSign" + (signatureElement.SignatureNo - 1)
				// iSignature.style.top = signatureElement.Top + 'px'
				// iSignature.style.left = signatureElement.Left + 'px'

				var header = document.createElement('div')
				header.innerHTML = ''
				header.className = 'header'
				header.id = iSignature.id + "header"
				iSignature.appendChild(header)

				// Signature
				var divSignerImage = document.createElement('div');
				divSignerImage.className = 'signature';
				divSignerImage.innerHTML = 'Signature ' + signatureElement.SignatureNo;

				// text
				var divText = document.createElement('div')
				divText.id = "text" + (signatureElement.SignatureNo - 1)
				divText.className = 'text'
				divText.innerHTML = ''				
				if (signatureElement.ShowSigneeName == true)
					divText.innerHTML += this.signers[signatureElement.SignatureNo - 1].name + '<br />'

				if (signatureElement.ShowSigneePosition == true)
					divText.innerHTML += this.signers[signatureElement.SignatureNo - 1].jobTitle + '<br />'

				if (signatureElement.ShowSignDate == true)
					divText.innerHTML += new Date().toLocaleDateString("en-GB")

				if (signatureElement.alignment == 0)
					divText.style.justifyContent = 'flex-start'

				else if (signatureElement.alignment == 1)
					divText.style.justifyContent = 'center'

				else if (signatureElement.alignment == 2)
					divText.style.justifyContent = 'flex-end'

				var content = document.createElement('div')
				content.className = 'content';
				content.id = "content" + (signatureElement.SignatureNo - 1);
				content.appendChild(divSignerImage);
				content.appendChild(divText);
				
				iSignature.appendChild(content);

				// document.getElementById('div1').appendChild(iSignature);
				document.getElementsByClassName('annotationLayer')[0].appendChild(iSignature);
				
				var currentContainerRect = document.getElementsByTagName('canvas')[0].getBoundingClientRect()
				var currentContainerWidth = parseInt(document.getElementsByTagName('canvas')[0].style.width.replace('px',''))
				var currentContainerHeight = parseInt(document.getElementsByTagName('canvas')[0].style.height.replace('px',''))

				var orginalContainerWidth = 1 / signatureElement.WidthScale
				var xCorrdinate = (signatureElement.X / orginalContainerWidth) * currentContainerWidth 
				var left = xCorrdinate - currentContainerRect.x

				var orginalContainerHeight = 1 / signatureElement.HeightScale
				var yCorrdinate = (signatureElement.Y / orginalContainerHeight) * currentContainerHeight
				var top = yCorrdinate - currentContainerRect.y + this.fixedHeaderSize;

				iSignature.style.top = top + 'px'
				iSignature.style.left = left + 'px'

				// dragElement(iSignature);
			},
			removeSignature(signatureIndex)
			{
				if (this.signers[signatureIndex].applyTo == 'this')
				{
					for (var i = 0; i < this.finalSignatureList.length; i++)
					{
						if (this.finalSignatureList[i].PageNo == this.page)
						{
							for (var j = 0; j < this.finalSignatureList[i].SignInfo.length; j++)
							{
								if (this.finalSignatureList[i].SignInfo[j].SignatureNo == signatureIndex + 1)
								{
									this.finalSignatureList[i].SignInfo.splice(j, 1)
								}
							}
						}
					}
				}
				else if (this.signers[signatureIndex].applyTo == 'all')
				{
					for (var i = 0; i < this.finalSignatureList.length; i++)
					{
						for (var j = 0; j < this.finalSignatureList[i].SignInfo.length; j++)
						{
							if (this.finalSignatureList[i].SignInfo[j].SignatureNo == signatureIndex + 1)
							{
								this.finalSignatureList[i].SignInfo.splice(j, 1)
							}
						}
					}
				}
				else if (this.signers[signatureIndex].applyTo == 'range')
				{
					for (var i = 0; i < this.finalSignatureList.length; i++)
					{
						var fromPage = this.signers[signatureIndex].from
						var toPage = this.signers[signatureIndex].to

						if (this.finalSignatureList[i].PageNo >= fromPage && this.finalSignatureList[i].PageNo <= toPage)
						{
							for (var j = 0; j < this.finalSignatureList[i].SignInfo.length; j++)
							{
								if (this.finalSignatureList[i].SignInfo[j].SignatureNo == signatureIndex + 1)
								{
									this.finalSignatureList[i].SignInfo.splice(j, 1)
								}
							}
						}
					}
				}
				else if (this.signers[signatureIndex].applyTo == 'specific')
				{
					for (var i = 0; i < this.finalSignatureList.length; i++)
					{
						var pagesArr = this.signers[signatureIndex].specific.split(',')[0]

						if (pagesArr.indexOf(this.finalSignatureList[i].PageNo) > -1)
						{
							for (var j = 0; j < this.finalSignatureList[i].SignInfo.length; j++)
							{
								if (this.finalSignatureList[i].SignInfo[j].SignatureNo == signatureIndex + 1)
								{
									this.finalSignatureList[i].SignInfo.splice(j, 1)
								}
							}
						}
					}
				}

				this.drawSignaturesOnPage()
				this.signatureConfigurationPanelChanged(signatureIndex)
			},
			applyChanges(signatureIndex)
			{
				this.removeSignature(signatureIndex)
				this.addSignatureToFile(signatureIndex)
			},
			getSigntureObject(pageNumber, signatureIndex)
			{
				var signatureDiv = document.getElementById("iSign" + signatureIndex).getBoundingClientRect();

				console.log('signatureDiv.x: ' + signatureDiv.x + ', signatureDiv.y: ' + signatureDiv.y)
				console.log('this.signers.x: ' + this.signers[signatureIndex].x + ', this.signers.y: ' + this.signers[signatureIndex].y)
				return {
						"SignatureNo": (signatureIndex + 1),
						"GCTId": 0,
						"WidthScale": 1 / parseInt(document.getElementsByTagName('canvas')[0].style.width.replace('px','')),
						"HeightScale": 1 / parseInt(document.getElementsByTagName('canvas')[0].style.height.replace('px','')),
						"Width": signatureDiv.width,
						"Height": signatureDiv.height,
						"X": this.signers[signatureIndex].x,
						"Y": this.signers[signatureIndex].y,
						"IsArabic": this.signers[signatureIndex].language == 'AR' ? true : false,
						"ShowSigneeName": this.signers[signatureIndex].showName,
						"ShowSigneePosition": this.signers[signatureIndex].showJobTitle,
						"ShowSignDate": this.signers[signatureIndex].showDate,
						"ShowStamp": false,
						"SignAlign": this.signers[signatureIndex].alignment,
					}
			},
			displayNextPage()
			{
				this.handleFunctionAfterRender = null
				this.page += 1
				this.handleFunctionAfterRender = () => {
					this.drawSignaturesOnPage()
					this.expansionPanels = -1
				}
			},
			displayPrevPage()
			{
				this.handleFunctionAfterRender = null
				this.page -= 1
				this.handleFunctionAfterRender = () => {
					this.drawSignaturesOnPage()
					this.expansionPanels = -1
				}
			},
			drawSignaturesOnPage()
			{
				// remove all elements from the page
				var elements = document.getElementsByClassName('movable_signature');
				while(elements.length > 0){
					elements[0].parentNode.removeChild(elements[0]);
				}

				// add the signatures to the page
				for (var i = 0; i < this.finalSignatureList.length; i++)
				{
					if (this.finalSignatureList[i].PageNo == this.page)
					{
						for (var j = 0; j < this.finalSignatureList[i].SignInfo.length; j++)
						{
							this.drawSignatureElement(this.finalSignatureList[i].SignInfo[j])
						}
					}
				}
			},
			signatureConfigurationPanelChanged(index)
			{
				// removing the drag event on the old signature
				removeDragElement(document.getElementById("iSign" + this.index))
	
				this.index = index
				var isSignatureFoundForCurrentPage = false
				var signatureNumber = this.signers[index].id

				for (var i = 0; i < this.finalSignatureList.length; i++)
				{
					if (this.finalSignatureList[i].PageNo == this.page)
					{
						for (var j = 0; j < this.finalSignatureList[i].SignInfo.length; j++)
						{
							if (this.finalSignatureList[i].SignInfo[j].SignatureNo == signatureNumber)
							{
								isSignatureFoundForCurrentPage = true
								break
							}
						}
					}
				}

				this.signers[index].showAdd = !isSignatureFoundForCurrentPage
				this.signers[index].showApplyChanges = isSignatureFoundForCurrentPage

				dragElement(document.getElementById("iSign" + index))
			},
			saveSignatures()
			{
				var finalSignaturesList = JSON.stringify(this.finalSignatureList);
				
				var requestObj = {
					documentId: this.documentId,
					attachmentId: this.attachmentId,
					signatureConfiguration: finalSignaturesList
				}

				axios.post(constants.baseApiUrl + 'Document/SaveSignatureConfiguration', requestObj)
					.then(response => this.closeDialog())
					.catch(err => console.log(err))
			},			
			reset()
			{
				// remove all elements from the page
				var elements = document.getElementsByClassName('movable_signature');
				while(elements.length > 0){
					elements[0].parentNode.removeChild(elements[0]);
				}

				this.finalSignatureList = []
				this.page = 1
				this.expansionPanels = -1
				this.signers = []
			},
            closeDialog()
            {
				this.$emit('closeDialog')
            },
			populateSignersList(lst)
			{
				if (lst.length > 0)
				{
					lst.forEach(element => 
					{
						var userData = element.split("#")

						this.signers.push({
							id: userData[0],
							name: userData[1],
							jobTitle: userData[2],
							applyTo: 'this',
							language: 'EN',
							alignment: 'left',
							showName: true,
							showJobTitle: true,
							showDate: true,
							showAdd: true,
							showApplyChanges: false,
							x: 550,
							y: 300,
							left: 550,
							top: 300
						});
					})
				}
			},
			populateMultiselectSelectedSignees(lst)
			{
				this.signers = []
				if (lst.length > 0)
				{
					lst.forEach(element => {
						this.signers.push({
							id: element.id,
							name: element.name
						});
					})
				}
			},
			asyncFindUser (query)
			{
				var methodUrl = 'StructureUser/get-structure-users?showUsers=true&showInternalStructures=false&showExternalStructures=false&search=';

				axios.get(constants.baseApiUrl + methodUrl + query, {headers: constants.headers})
					.then((res) =>
					{
						this.users = res.data;
					}).catch(err => console.warn(err))
			},
			doneAttachment()
			{
				if (this.maxNumberOfSigners == 0 && this.signeesList.length == 0)
				{
					this.populateMultiselectSelectedSignees(this.dynamicSignees);
				}
				else if(this.maxNumberOfSigners > 0)
				{
					this.populateMultiselectSelectedSignees(this.signees);
					this.maxNumberOfSigners = 0;
				}
			},
			addAttachment()
			{
				this.dynamicUserList.push(this.counter);
				this.counter += 1;
				
			},
			deleteVisa(index)
			{
				this.dynamicUserList.splice(index, 1)
			},
		}
	}

	function removeDragElement(elmnt)
	{
		if (elmnt == null)
			return;
		
		document.getElementById(elmnt.id + "header").onmousedown = null;
		document.onmouseup = null;
		document.onmousemove = null;
	}

	function dragElement(elmnt) 
	{
		if (elmnt == null)
			return;

		var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
		
		if (document.getElementById(elmnt.id + "header")) 
		{
			document.getElementById(elmnt.id + "header").onmousedown = dragMouseDown;
		}

		function dragMouseDown(e) 
		{
			e = e || window.event;
			e.preventDefault();
			pos3 = e.clientX;
			pos4 = e.clientY;
			document.onmouseup = closeDragElement;
			document.onmousemove = elementDrag;
		}

		function elementDrag(e) 
		{
			e = e || window.event;
			e.preventDefault();
			pos1 = pos3 - e.clientX;
			pos2 = pos4 - e.clientY;
			pos3 = e.clientX;
			pos4 = e.clientY;
			elmnt.style.top = (elmnt.offsetTop - pos2) < 0 ? 0 : (elmnt.offsetTop - pos2) + "px";
			elmnt.style.left = (elmnt.offsetLeft - pos1)  < 0 ? 0 : (elmnt.offsetLeft - pos1) + "px";

		}

		function closeDragElement() 
		{
			document.onmouseup = null;
			document.onmousemove = null;

			var signatureDiv = document.getElementById("iSign0").getBoundingClientRect();
			
			console.log('signatureDiv.x: ' + signatureDiv.x + ', signatureDiv.y: ' + signatureDiv.y)
			console.log('elmnt.getBoundingClientRect().x: ' + elmnt.getBoundingClientRect().x 
				+ ', elmnt.getBoundingClientRect().y: ' + elmnt.getBoundingClientRect().y)
				
			window.setXAndY(elmnt.getBoundingClientRect().x, elmnt.getBoundingClientRect().y,
				elmnt.style.left, elmnt.style.top);
		}
	}
</script>

<style>
	#div 
	{
		border: 1px dotted #000;
		position: absolute;
	}
    .movable_signature
    {
        position: absolute;
		z-index: 1;
        /* top: 319px;
        left: 548px; */

		width: 225px;
		min-width: 150px;
		max-width: 300px;

		min-height: 100px;
		max-height: 200px;
		height: 176px;
		
        background-color: white;
        resize: both;
        overflow: hidden;
		box-shadow: 0px 0px 15px #98989829;
		border-radius: 8px;
		opacity: 0.9;
    }

    .movable_signature .header
    {
        height: 30px; 
        background-color: aliceblue;
        cursor: pointer;
		text-align: right;
		padding-right: 8px;
		padding-left: 8px;
		padding-top: 4px;
    }

	.movable_signature .content
    {
        height: calc(100% - 30px);
    }

    .movable_signature .signature
    {
		font-size: 25px;
        width: 100%;
		height: calc(100% - 60px);
		border: solid 0px black;
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 50px;

    }

	.text
	{
		color: black;
		font-size: 14px;
		width: inherit;
		height: fit-content;
		display: flex;
	}
    
</style>